export default "__VITE_ASSET__F8lSe45s__"